import { render, staticRenderFns } from "./reports-box.vue?vue&type=template&id=68412940&scoped=true"
import script from "./reports-box.vue?vue&type=script&lang=js"
export * from "./reports-box.vue?vue&type=script&lang=js"
import style0 from "./reports-box.vue?vue&type=style&index=0&id=68412940&prod&lang=css"
import style1 from "./reports-box.vue?vue&type=style&index=1&id=68412940&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68412940",
  null
  
)

export default component.exports